"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_STATIC_ARTICLES = exports.GET_LANDING_PAGES = exports.GET_ALL_ITEMS = void 0;
exports.GET_ALL_ITEMS = `{
  getAllItemsForSitemap
}`;
exports.GET_LANDING_PAGES = `{
  getLandingPages
}`;
exports.GET_STATIC_ARTICLES = `{
  getStaticArticles
}`;
//# sourceMappingURL=ssr-queries.js.map